import Decimal from 'decimal.js-light'

export const toDecimal = value => new Decimal(value)



/** WEBPACK FOOTER **
 ** ./src/utils/decimal/decimal.js
 **/